import SectionHeading from "@/components/base/SectionHeading";
import { collections } from "@/mocks/home";
import { getDetailRoute } from "@/utils/media";

export default function CollectionsSection() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <SectionHeading title="推荐专题集合" subtitle="由影迷精心整理的观影片单，带你发现更多好内容" />
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
          {collections.map((collection) => (
            <article
              key={collection.id}
              className="rounded-lg overflow-hidden bg-background-50 ring-1 ring-background-200/70 flex flex-col"
            >
              <div className="relative h-40 md:h-44 overflow-hidden">
                <img
                  src={collection.cover}
                  alt={`${collection.title}专题封面`}
                  title={`${collection.title} - 天堂电影网专题`}
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 to-transparent" />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                  <i className="ri-bookmark-3-line" aria-hidden="true" />
                  {collection.count} 部作品
                </span>
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className="font-heading text-xl font-bold text-foreground-950">{collection.title}</h3>
                  <p className="text-xs text-accent-300 mt-0.5">{collection.subtitle}</p>
                </div>
              </div>
              <div className="p-4 grid grid-cols-4 gap-3">
                {collection.items.map((item) => (
                  <a
                    key={item.id}
                    href={getDetailRoute(item.type, item.id)}
                    className="group block cursor-pointer"
                    title={item.title}
                  >
                    <div className="relative poster-ratio w-full overflow-hidden rounded-md bg-background-200">
                      <img
                        src={item.poster}
                        alt={`${item.title}海报`}
                        title={`${item.title} - 天堂电影网`}
                        className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <p className="mt-1.5 text-[11px] text-foreground-500 line-clamp-1 group-hover:text-accent-400 transition-colors">
                      {item.title}
                    </p>
                  </a>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}